import WebServiceRequest from "../Api/WebServiceRequest";

class CreateFile extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Media/CreateFile");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}

class UploadFile extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Upload");
  }
  setParams(data) {
    super.setFormData(data);
  }
}

class GetLibraryFiles extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Media/GetLibraryFiles");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class DeleteAMedia extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Media/DeleteByPictureUrl");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetLatestBannerVideo extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setMethod("GET")
    super.setTag("Media/GetLatestBannerVideo");
  }
}

class MediaUpload extends WebServiceRequest {
  constructor (context) {
    super(context)
    super.setTag('Media/Upload')
  }
  setParams(data){
    super.setRequestParam(data)
  }
  setFormPrams(data){
    super.setFormData(data)
  }
}

class MediaSaveImagesWithWatermark extends WebServiceRequest {
  constructor (context) {
    super(context)
    super.setTag('Media/SaveImagesWithWatermark')
  }
  setParams(data){
    super.setRequestParam(data)
  }
  setFormPrams(data){
    super.setFormData(data)
  }
}

export { CreateFile, GetLibraryFiles, DeleteAMedia , GetLatestBannerVideo , MediaUpload , MediaSaveImagesWithWatermark , UploadFile};
